import Moment from 'moment';
import { Component ,Mixins, Prop } from 'vue-property-decorator';
import { EdContextMenuOptionsModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import { SectionsProvider  } from '@/content/providers/sections.provider';
import { COURSE_EVENTS } from '@/content/values/events';
import { LocalStorageService } from '@/services/local-storage.service';
import { COURSE_STORAGE_KEYS } from '@/courses/values/courses.values';
import { IResponseConfirmationModal } from '@/plugins/ed-modal/interfaces/response-confirmation-modal.interface';
import EdSectionFolderIcon from '../ed-section-folder-icon/ed-section-folder-icon.vue';
import { MaterialMixin } from '@/courses/mixins/material.mixin';
import ToolService from '@/providers/tools';
import EdConfirmMessageComponent from '../ed-confirm-message/ed-confirm-message.component.vue';


@Component({
  name: 'ed-section-material-title',
  components: {
    EdSectionFolderIcon,
    EdConfirmMessageComponent
  }
})
export default class EdSectionMaterialTitle extends Mixins(MaterialMixin) {

  /* Props */
  @Prop() readonly level : number; 
  @Prop() readonly opened : boolean; 
  @Prop() readonly selected : boolean;
  @Prop() readonly menuOptions: any[];

  /* Data */
  public titleID: string = ''
  public materialTitle: string = '';
  public menuSectionOptions: any[]= [];
  public teacherOnly: boolean = false;

  /* Computed */
  get nodes() {
    return this.course.materials.nodes;
  }

  get materialsList() {
    return this.course.materialsList;
  }

  get state(): any {
    let paddingLeft: string = `edg-pad-left--${this.level * 10}`;
    return { 
      opened: { 'ed-icon--is-opened': this.opened }, 
      container: { 
        'ed-section-material-title--is-selected': this.selected,
        [paddingLeft]: true
      }, 
      icon:  this.opened ? 'folder-open' : 'folder'
    }
  }

  get nameStyle(): any {
    return { maxWidth: `calc(100% - ${this.membersConnected.length * 15}px` };
  }

  get opacity(){
    if(this.teacherOnlyComp)
      return { opacity:'0.5' }
  }

  get teacherOnlyComp() {
    let parent = SectionsProvider.getSectionMaterialFromId(this.nodes, this.section.parentId);
    if(parent) {
      return parent.teacherOnly ? parent.teacherOnly : this.section.teacherOnly;
    } else {
      return this.section.teacherOnly;
    }
  }

  get escapedName(){
    return ToolService.exitSpecialChars(this.materialTitle);
  }

  get membersConnected() {
    return this.$store.state.AppStore.membersPosition.filter(m => {

      let childrenMaterialSelected = !m.isFolder ? SectionsProvider
        .findCurrentCourseMaterial(
          this.section, m.sectionId
        ) : false;

      let childrenNodesSelected = m.isFolder ? SectionsProvider
      .getSectionMaterialFromId(
        this.section.nodes, m.sectionId
      ) : false;

      let folderSelected = (m.sectionId == this.section.sectionId && m.isFolder);

      return (
        m.courseId == this.courseID && 
        m.classId == this.classID &&
        (childrenMaterialSelected || childrenNodesSelected || folderSelected)
      );
      
    });
  }

  /* Methods */
  public toggleOpened() {
    this.$emit('open', this.section);    
  }

  public selectItem() {
    this.options.selectable ? this.$emit('goToSection' , this.section) : null;
  }

  async selectEditOption(optionSelected: EdContextMenuOptionsModel) {
    if(optionSelected.type) {
      if(`${optionSelected.type}_MATERIAL` === COURSE_EVENTS.REMOVE_SECTION_MATERIAL) {
        this.confirmRemove();
      } else {
        this.$emit('goToSection' , this.section);
      }
    }
  }

  public confirmRemove() {
    let time = LocalStorageService.getItem(COURSE_STORAGE_KEYS.EXPIRED_TIME_CONFIRM_REMOVE_MATERIAL_SECTION);
    if(time) {
      if(Moment().isBefore(Moment(time))) {
        this.removeMaterialSection();
        return;
      } else {
        LocalStorageService.removeItem(COURSE_STORAGE_KEYS.EXPIRED_TIME_CONFIRM_REMOVE_MATERIAL_SECTION);
      }
    }
    this.$EdModal.createConfirmationModal({ 
      body: `${this.$i18n.t('courses.materials.deleteCourseMaterialSection')}`, 
      action: (res: IResponseConfirmationModal) => {
        if(res.optionSelected) {
          LocalStorageService.setItem(COURSE_STORAGE_KEYS.EXPIRED_TIME_CONFIRM_REMOVE_MATERIAL_SECTION, Moment().add(1, 'days'));
        }
        this.removeMaterialSection();
      },
      hasOptionCheck: true,
      labelOptionCheck: this.$i18n.t('courses.objects.dontAskeMe') 
    });
  }

  private removeMaterialSection() {
    this.editingObject = true;
    this.$emit('close')
    this.$Courses.Store.removeSectionMaterialA({
      sectionId: this.section.sectionId, courseId: this.courseID , classId: this.classID
    })
    .finally(() => {
      this.editingObject = false;
    });
  }

  public goToAddCourseMaterial(opt: any) {    
    this.$edEventBus.$emit(COURSE_EVENTS.ADD_COURSE_MATERIAL, 
    { option: opt, section: this.section });
  }

  public validateParentVisibility(parentSectionId){
    if(parentSectionId){
      let parentSection = SectionsProvider.getSectionMaterialListFromId(this.materialsList,parentSectionId);
      if(!this.teacherOnly){
        while(parentSection.teacherOnly){
          parentSection.teacherOnly = !parentSection.teacherOnly;
          this.setTeacherOnlyMaterial(parentSection);
          parentSection = SectionsProvider.getSectionMaterialListFromId(this.materialsList,parentSectionId.parentId);
          if(parentSection == null){
            return;
          }
        }
      }
      else{
        while(parentSection.materialsList.filter(el => el.data).length == parentSection.materialsList.filter(material => material.data?.teacherOnly == true).length &&
              parentSection.materialsList.filter(el => !el.data).length == parentSection.materialsList.filter(section => { 
                if(section.teacherOnly || section.sectionId == this.section.sectionId)
                  return section;
              }).length){      
          parentSection.teacherOnly = !parentSection.teacherOnly;
          this.setTeacherOnlyMaterial(parentSection);
          parentSection = SectionsProvider.getSectionMaterialListFromId(this.materialsList,parentSectionId.parentId);
          if(parentSection == null){
            return;
          }
        }
      }
    }
  }

  public validateChildrenVisibility(section, status){
    if (section.materialsList.length > 0) {
      section.materialsList.forEach(material => {
        if(material.data) {
          if(material.data.teacherOnly != status){
            material.data.teacherOnly = status;
            this.setTeacherOnlyMaterial(material);
          }
        } else {
          if(material.teacherOnly != status){
            material.teacherOnly = status;
            this.setTeacherOnlyMaterial(material);
          }
          this.validateChildrenVisibility(material,status);
        }
      })
    }
  }

  public changeVisible() {
    if(this.course.showTeacherOnlyMessage) {
      this.$EdModal.createModal(EdConfirmMessageComponent, {
        onConfirmMessage: this.confirmMessage
      })
    } else {
      this.changeVisibleAction();
    }
  }

  public changeVisibleAction() {
    this.teacherOnly = !this.teacherOnlyComp;

    let updatedSection = { ...this.section };
    updatedSection.teacherOnly = this.teacherOnly;
    updatedSection.saveMessageTeacherOnly = this.dontAskAgaingTeaherOnly;
    this.setTeacherOnlyMaterial(updatedSection);

    this.validateChildrenVisibility(this.section,this.teacherOnly);
    this.validateParentVisibility(this.section.parentId);
  }

  confirmMessage(data) {
    this.dontAskAgaingTeaherOnly = data;
    this.changeVisibleAction();
  }

  /* Hooks */
  created() {
    let text: any = this.$i18n;
    this.menuSectionOptions = SectionsProvider.getEditSectionMenu(text);
    this.titleID = this.section.sectionId;
    this.materialTitle = this.section.sectionName;    
    this.teacherOnly = this.section.teacherOnly; 
  }
  
}